@for (client of clients(); track client.id; let first = $first) {
<lib-link [routerLink]="client.routerLink" [linkStyle]="'noUnderline'">
	<lib-card
		[subtitle]="client.latestChatMessageWithTrainer ? fromNow(client.latestChatMessageWithTrainer.created) : ''"
		[avatar]="client.avatar"
		[avatarName]="client.fullName"
		[title]="client.fullName"
		[class.push-top]="!first"
	>
		@if (client.latestChatMessageWithTrainer) {
		<div>
			{{ client.latestChatMessageWithTrainer.message }}
		</div>
		} @else {
		<em>No messages yet</em>
		}

		<div class="push-top" libFlexRow [libFlexRowAlign]="'start'">
			<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
				<lib-button [buttonType]="'primaryLight'" [icon]="'email'">View chat</lib-button>
			</div>
		</div>
	</lib-card>
</lib-link>
}
